import * as segmentio from 'rp-analytics';

/*
Subscribe section (case 1)
-----------------
/subscriptions
/subscriptions/matrix
/subscriptions/payment

My Account section
------------------
(case 2)
- /subscriptions/my-account/email-confirmation
- /subscriptions/confirm
- all other not mentioned /subscriptions/my-account/*

    Section 1 is not null
    ---------------------
    Profile section1 - /subscriptions/my-account/ (default) + /#tab=account (case 3)
    Subscriptions section1 - /subscriptions/my-account/#tab=subscriptions (case 4)

Members Club section
--------------------
- all other not mentioned /subscriptions/* (case 5)
*/

const state = {
  section: null,
  section1: null,
};

export default function analyticsPage() {
  const pathnameSplit = global.location.pathname.split('/');
  const tabHash = global.location.hash;

  const firstLevel = pathnameSplit[2];
  const secondLevel = pathnameSplit[3];

  let newSection = null;
  let newSection1 = null;

  if (!firstLevel || firstLevel === 'matrix' || firstLevel === 'payment') {
    // case 1
    newSection = 'Subscribe';
    newSection1 = null;
  } else if (firstLevel === 'my-account') {
    // case 2
    newSection = 'My Account';
    newSection1 = null;
    if (!secondLevel) {
      if (!tabHash || tabHash === '#tab=account') {
        // case 3
        newSection1 = 'Profile';
      }
      if (tabHash === '#tab=subscriptions') {
        // case 4
        newSection1 = 'Subscriptions';
      }
    }
  } else {
    // case 5
    newSection = 'Members Club';
    newSection1 = null;
  }

  if (state.section && state.section === newSection && state.section1 === newSection1) {
    return;
  }

  state.section = newSection;
  state.section1 = newSection1;

  segmentio.setCommonTraits({
    [segmentio.TRAIT_SITE_SECTION]: newSection,
    [segmentio.TRAIT_SITE_SUB_SECTION_1]: newSection1,
    [segmentio.TRAIT_SITE_SUB_SECTION_2]: null,
  });

  segmentio.page();
}
